import "../styles/genai.css";
import agenticAIHeroImg from "../assets/agentic-ai-hero.png";

export default function AgenticAIHero() {
  return (
    <section
      className="genai-hero full-hero"
      style={{
        backgroundImage: `url(${agenticAIHeroImg})`,
      }}
    >
      {/* OVERLAY */}
      <div className="hero-overlay"></div>

      {/* CONTENT */}
      <div className="hero-content">
        <h1 className="hero-title">
          AGENTIC AI CAREER TRACK
        </h1>

        <p className="hero-desc">
          Learn to Build Autonomous AI Agents that Plan, Reason, and Execute Tasks
        </p>

      </div>
    </section>
  );
}